export default () => ({
  users: [],
  user: {},
  partners: [],
  stores: [],
  areps: {},
});
